import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"
import { msToSeconds } from "../utils/time"

export default function useWeeklyObjectives() {
  const query = useQuery({
    queryKey: ["planner-get-weekly-objectives"],
    queryFn: async () => {
      const data = await api.cronos.weeklyObjectives.get()
      const weeks = data.data.description.weeks.map((week, i) => {
        const totalSeconds = msToSeconds(week.totalEstimatedDuration)
        return {
          ...week,
          id: Math.random().toString(36).substr(2, 9),
          totalSeconds,
          week: i + 1,
        }
      })

      return {
        data: data.data.description,
        weeks,
      }
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: true,
  })

  return query
}
